var range = function range(min, max) {
  return {
    min: min,
    max: max
  };
};
var px = function px(num) {
  return "".concat(num, "px");
};
var ranges = {
  xs: range(0, 479.98),
  sm: range(480, 767.98),
  md: range(768, 1023.98),
  lg: range(1024, 1191.98),
  xl: range(1192, 1359.98),
  xxl: range(1360, Infinity)
};
var inMobile = "max-width: ".concat(px(ranges.sm.max));
var inDesktop = "min-width: ".concat(px(ranges.md.min));
export default {
  xs: px(ranges.xs.min),
  xsMax: px(ranges.xs.max),
  sm: px(ranges.sm.min),
  smMax: px(ranges.sm.max),
  md: px(ranges.md.min),
  mdMax: px(ranges.md.max),
  lg: px(ranges.lg.min),
  lgMax: px(ranges.lg.max),
  xl: px(ranges.xl.min),
  xlMax: px(ranges.xl.max),
  xxl: px(ranges.xxl.min),
  inMobile: inMobile,
  inDesktop: inDesktop,
  ranges: ranges
};